module.exports = __webpack_public_path__ + "assets/391303b1d5f69f6222fa4ed83a3bee0e.mp3";